"use client"

import { VideoElement } from "@/elements"
import { useOutOfView } from "@/hooks/useOutOfView"
import { useEffect, useRef, useState } from "react"
import { MediaBlock } from "../articles/[slug]/blocks/MediaBlock"
import clsx from "clsx"

export type MediaItemProps = MediaBlock & {
  autoplay?: boolean
  playInView?: boolean
  rounded?: boolean
}

export const MediaItem = ({ file, playInView = false, autoplay = false, rounded = true }: MediaItemProps) => {
  const [showControls, setShowControls] = useState(false)
  const videoRef = useRef<HTMLVideoElement>(null)
  const contianerRef = useRef<HTMLDivElement>(null)
  const outOfView = useOutOfView(contianerRef, {
    threshold: 0.5,
  })

  useEffect(() => {
    if (!videoRef.current || !playInView) return

    if (!outOfView) {
      videoRef.current.play().catch(() => {})
    } else {
      videoRef.current.pause()
    }
  }, [outOfView, playInView])

  if (file.type.includes("video")) {
    return (
      <div ref={contianerRef}>
        <VideoElement
          title={file.title}
          autoPlay={autoplay}
          ref={videoRef}
          muted={true}
          loop={true}
          playsInline={true}
          onMouseEnter={() => setShowControls(true)}
          onMouseLeave={() => setShowControls(false)}
          style={{
            aspectRatio: file.width / file.height,
            width: "100%",
          }}
          className={clsx(rounded && "rounded-md")}
          controls={showControls}
          src={`${process.env.NEXT_PUBLIC_DIRECTUS_CLOUDFRONT_DOMAIN}/hls-output/${file.id}/${file.id}.m3u8`}
        />
      </div>
    )
  }
  return (
    <img
      src={`${process.env.NEXT_PUBLIC_DIRECTUS_CLOUDFRONT_DOMAIN}/public/${file.filename_disk}`}
      alt={file.title || "Image"}
      title={file.title}
      width={file.width}
      height={file.height}
      className={clsx(rounded && "rounded-md", "h-auto w-full")}
      onContextMenu={e => e.preventDefault()}
      loading="lazy"
      style={{
        aspectRatio: `${file.width} / ${file.height}`,
      }}
    />
  )
}
